module.exports = "/images/vendor/vue-paycard/src/4.jpg?96a6801e5dd3239cf33944d830b7fb42";